WiseMetering.Collection.Utilities = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Utility,
    url: '/utilities'
});
